import { FunctionComponent, ReactNode } from 'react';

import { Text, Box, Card, Badge } from 'design-system';

import './ExperienceCard.scss';

interface ExperienceCardProps {
  company: string | ReactNode;
  position?: string;
  dates?: string;
  description?: string;
  skills?: string[];
}

export const ExperienceCard: FunctionComponent<ExperienceCardProps> = ({
  company,
  position,
  dates,
  description,
  skills = [],
}) => {
  return (
    <Card className="experience-card">
      <Box className="experience-card-details">
        <Text as="div" size="3" weight="bold">
          {company}
        </Text>
        {position && (
          <Text as="div" size="2" weight="bold">
            {position}
          </Text>
        )}
        {dates && (
          <Text as="div" size="1" weight="bold">
            {dates}
          </Text>
        )}
        {description && (
          <Text as="div" size="1">
            <br />
            <Text as="div" color="gray" size="1">
              {description}
            </Text>
          </Text>
        )}
        {skills.map((skill) => (
          <Badge className="skill-badge">{skill}</Badge>
        ))}
      </Box>
    </Card>
  );
};
